export default __webpack_public_path__ + "static/media/CardImg2.3a20b209.jpg";